import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadRecoveryEVSDetails = (defaultSite, date) => {
    const offlineService = new OfflineService();

    HttpService.post('/RecoveryEVS/GetAppVisitationRecoveries', {
        AppVisitationId: 0,
        SiteId: defaultSite.id,
        GeoLocation: 0,
        VisitDate: date,
        IssueTypeId: 0,
        PriorityId: 0,
        Resolved: false
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationRecoveries");
        offlineService.addOffline(defaultSite.id, "AppVisitationRecoveries", result);
    },
    (error) => {
        console.log(error);
    });
};

const LoadVisitationAnswers = (defaultSite) => {
    const offlineService = new OfflineService();

    HttpService.post('/VisitationEVS/GetAppVisitationAnswers', { AppVisitation: 0 })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }

        offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationAnswers");
        offlineService.addOffline(defaultSite.id, "AppVisitationAnswers", result.data);
    },
    (error) => {
        console.log(error);
    });
};

const SaveRecoveryEVSOfflineData = async (siteId, entityId, keyName, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, item);
        }
        else {
            offlineSyncService.updateById(exists.Id, item);
            id = exists.Id;
        }
    }

    UpdateOfflineData(siteId, item, remove);
    return id;
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "AppVisitationRecoveries");
    const data = offlineResult.OfflineData.data;
    const index = data.findIndex(d => d.AppVisitationRecoveryId === item.AppVisitationRecoveryId);

    if (remove) {
        offlineResult.OfflineData.data.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.data.push(item);
    else {
        offlineResult.OfflineData.data[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "AppVisitationRecoveries", offlineResult.OfflineData);
};

export { LoadRecoveryEVSDetails, LoadVisitationAnswers, SaveRecoveryEVSOfflineData };
